import type { ShapeKind, Tone } from '@didto/ui';

export type DeviceState = 'online' | 'offline' | 'not_enrolled' | 'revoked';

/** A device's state as staff see it (Dashboard, Devices): a word, a tone and a shape, never colour alone. */
export const DEVICE_STATE: Record<DeviceState, { label: string; tone: Tone; shape: ShapeKind }> = {
  online: { label: 'online', tone: 'success', shape: 'dot' },
  offline: { label: 'offline', tone: 'warning', shape: 'ring' },
  not_enrolled: { label: 'not enrolled', tone: 'info', shape: 'diamond' },
  revoked: { label: 'revoked', tone: 'danger', shape: 'square' },
};

/**
 * Revoked and not yet enrolled come from the device's record; an enrolled device is online while its
 * last check-in is younger than the threshold (terminal.online_threshold_seconds).
 */
export function deviceState(
  t: { status: string; last_seen_at: string | null },
  now: number,
  thresholdSeconds: number,
): DeviceState {
  if (t.status === 'revoked') return 'revoked';
  if (t.status !== 'active') return 'not_enrolled';
  return t.last_seen_at && now - new Date(t.last_seen_at).getTime() < thresholdSeconds * 1000
    ? 'online'
    : 'offline';
}
